document.addEventListener("DOMContentLoaded", function() {
    function updateTexts() {
        // Ändern des Textes "Abholung im Geschäft" in "Abholung auf der FBM"
        var pickupOption = document.querySelector("#pickup-options option[value='store_pickup']");
        if (pickupOption) {
            pickupOption.textContent = "Abholung auf der FBM";
        }

        // Ändern des Textes "Alle RegionenBitte wählen Sie einen Abholort, ein Datum und eine Uhrzeit aus:" in "Bitte wähle das Datum und eine Uhrzeit aus:"
        var regionText = document.querySelector(".pickup-location-text");
        if (regionText) {
            regionText.innerHTML = "Bitte wähle das Datum und eine Uhrzeit aus:";
        }

        // Ändern des Textes "Wählen Sie einen Liefertermin" in "Wähle einen Abholtermin"
        var deliveryTerm = document.querySelector("label[for='delivery_date']");
        if (deliveryTerm) {
            deliveryTerm.textContent = "Wähle einen Abholtermin";
        }

        // Ausblenden des zusätzlichen Textes
        var additionalText = document.querySelector(".delivery-instructions");
        if (additionalText) {
            additionalText.style.display = "none";
        }
    }

    // Wiederholtes Ausführen der Funktion, bis alle Elemente verfügbar sind
    var checkExist = setInterval(function() {
        var pickupOption = document.querySelector("#pickup-options option[value='store_pickup']");
        var regionText = document.querySelector(".pickup-location-text");
        var deliveryTerm = document.querySelector("label[for='delivery_date']");
        var additionalText = document.querySelector(".delivery-instructions");

        if (pickupOption || regionText || deliveryTerm || additionalText) {
            updateTexts();
        }

        // Überprüfen, ob alle Elemente aktualisiert wurden und beenden das Intervall
        if (pickupOption && pickupOption.textContent === "Abholung auf der FBM" &&
            regionText && regionText.innerHTML === "Bitte wähle das Datum und eine Uhrzeit aus:" &&
            deliveryTerm && deliveryTerm.textContent === "Wähle einen Abholtermin" &&
            additionalText && additionalText.style.display === "none") {
            clearInterval(checkExist);
        }
    }, 100); // Überprüft alle 100 Millisekunden
});
